import Vue from 'vue'
import App from './App.vue'
import Home from './components/Home'
import VueResource from 'vue-resource'
import TwitterApi from 'twitter-node-client'
import VueLazyload from 'vue-lazyload'
import UserStream from 'user-stream'
import VueTruncate from 'vue-truncate-filter'
import vSelect from 'vue-select'
import VueScrollTo from 'vue-scrollto'
import _ from 'lodash'
import CheckboxRadio from 'vue-checkbox-radio'
import VueAnalytics from 'vue-analytics'
// import axios from 'axios'
// Vue.use(axios)
Vue.component('v-select', vSelect)
Vue.use(VueScrollTo)
Vue.use(require('vue-moment'));
Vue.use(UserStream)
Vue.use(VueResource)
Vue.use(TwitterApi)
Vue.use(VueLazyload)
Vue.use(VueTruncate)
Vue.use(_)
Vue.use(CheckboxRadio)

// Vue.http.options.crossOrigin = true
// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
// Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'
Vue.component('home',Home)

Vue.use(VueAnalytics, {
  id: 'UA-49160198-40'
})

new Vue({
  el: '#app',
  render: h => h(App),
  created() {
  }
})



// WEBPACK FOOTER //
// ./src/main.js